import React from 'react'
import { Checkbox, Form, Input, InputNumber, Select } from 'antd'
import { MaskedInput } from 'antd-mask-input'

const SettingsTable = (props) => {
  console.log(props.type)

  return (
    <>
      <Form.Item label='Name' name={`table_name_${props.index}`} hidden={props.hidden} initialValue={`${props.type.label} #${props.schedule.reduce((total, x) => (x === props.type.key ? total + 1 : total), 0)}`}>
        <Input />
      </Form.Item>
      <Form.Item label='Max Score' name={`table_score_${props.index}`} hidden={props.hidden} initialValue={12}>
        <InputNumber />
      </Form.Item>
      <Form.Item label='Max Bout Time' name={`table_duration_${props.index}`} hidden={props.hidden} initialValue='02:00'>
        <MaskedInput mask='0[0]:0[0]' className='duration' />
      </Form.Item>
      {
        props.schedule.length - 1 > props.selectedSchedule
          ? (
            <Form.Item label='Qualified' name={`table_promotion_${props.index}`} hidden={props.hidden} initialValue={4}>
              <Select>
                <Select.Option value={2}>2</Select.Option>
                <Select.Option value={4}>4</Select.Option>
                <Select.Option value={8}>8</Select.Option>
                <Select.Option value={16}>16</Select.Option>
                <Select.Option value={32}>32</Select.Option>
                <Select.Option value={64}>64</Select.Option>
              </Select>
            </Form.Item>
            )
          : (
            <Form.Item name={`table_fenceoff_${props.index}`} hidden={props.hidden} valuePropName='checked' initialValue>
              <Checkbox>Fence off for 3rd</Checkbox>
            </Form.Item>
            )
      }
    </>
  )
}

export default SettingsTable
